import { render, staticRenderFns } from "./DoctorReviewsMobile.vue?vue&type=template&id=c885f162&scoped=true&"
import script from "./DoctorReviewsMobile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorReviewsMobile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorReviewsMobile.vue?vue&type=style&index=0&id=c885f162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c885f162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c885f162')) {
      api.createRecord('c885f162', component.options)
    } else {
      api.reload('c885f162', component.options)
    }
    module.hot.accept("./DoctorReviewsMobile.vue?vue&type=template&id=c885f162&scoped=true&", function () {
      api.rerender('c885f162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/mobile/DoctorReviewsMobile.vue"
export default component.exports